import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
  selector: 'app-survey-status',
  templateUrl: './survey-status.component.html',
  styleUrls: ['./survey-status.component.css']
})
export class SurveyStatusComponent implements OnInit {

  public status:any;
  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
           

      if (typeof params.status != 'undefined' && params.status != '' && params.status != null)
        
     {
          this.status = params.status;
          
          
      }
      else {
          this.router.navigate(['not-found']);
      }
  });

   }

  ngOnInit(): void {
  }
 
}
